module.exports = __webpack_public_path__ + "assets/images/pages/eu-funds/Xunta-GAIN.png?c2adb69e";